var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPayrollLoansIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 217,
    viewBox: "0 0 240 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1817 174.728C14.1312 173.864 14.1055 172.994 14.1055 172.118C14.1055 147.731 33.9046 127.932 58.2918 127.932H65.6149",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1817 172.117C14.1312 172.981 14.1055 171.241 14.1055 172.117C14.1055 196.505 33.9046 216.304 58.2918 216.304H65.6149",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.035 190.523C131.149 190.523 136.925 196.299 136.925 203.414C136.925 210.528 131.149 216.304 124.035 216.304C116.92 216.304 111.145 210.528 111.145 203.414C111.145 196.299 116.92 190.523 124.035 190.523ZM220.033 203.377C223.6 203.377 226.497 206.273 226.497 209.841C226.497 213.408 223.6 216.304 220.033 216.304C216.466 216.304 213.57 213.408 213.57 209.841C213.57 206.273 216.466 203.377 220.033 203.377Z",
    fill: "#F2F4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8739 130.181C84.1432 123.721 79.1463 116.781 81.2139 113.2C82.3302 111.266 85.3244 110.627 89.4109 111.129C88.7439 116.634 89.6956 122.958 92.8739 130.181Z",
    fill: "#653494"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8739 130.181C84.1432 123.721 79.1463 116.781 81.2139 113.2C82.3302 111.266 85.3244 110.627 89.4109 111.129C88.7439 116.634 89.6956 122.958 92.8739 130.181Z",
    stroke: "black",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.128 125.264C111.862 126.916 109.646 117.948 100.028 114.087C91.9511 110.845 85.0633 110.013 82.1807 112.136C102.069 90.4644 144.326 86.5842 170.513 99.1821C174.16 100.951 176.763 104.331 177.544 108.309C178.324 112.286 177.191 116.399 174.484 119.416C168.491 126.045 149.279 134.716 149.279 134.716",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.562 148.876C129.091 150.783 129.619 152.688 130.058 154.269C130.739 156.727 130.366 159.358 129.028 161.53C129.028 161.53 110.485 191.25 105.461 199.041C102.347 203.872 95.398 193.186 97.591 187.724C102.413 173.695 107.129 163.615 112.324 157.466C93.7631 137.9 88.0073 122.704 89.4101 111.129L128.562 148.876ZM89.8185 202.35C89.2451 203.281 89.212 204.448 89.7319 205.41C91.1147 207.969 93.8297 212.994 95.027 215.21C95.391 215.884 96.0959 216.304 96.8622 216.304C98.9385 216.304 103.12 216.304 105.515 216.304C105.955 216.304 106.371 216.106 106.649 215.765C106.927 215.424 107.037 214.977 106.948 214.546C106.858 214.105 106.785 213.754 106.785 213.752C106.785 213.752 106.785 213.752 106.785 213.752C106.495 212.267 105.032 211.643 102.609 211.165C101.695 209.202 101.161 206.918 100.862 204.679C100.715 203.569 102.082 202.873 100.862 201.849C97.958 200.259 96.8887 201.85 96.7024 203.413C95.2499 201.929 94.6504 199.801 94.6387 197.676C94.6382 197.67 94.6356 197.664 94.6313 197.661C94.6265 197.658 94.6204 197.657 94.6151 197.658C92.2623 198.342 91.1081 200.224 89.8185 202.35Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.262 129.318L143.705 132.496C144.956 133.744 146.111 135.141 148.26 135.015C150.482 134.733 151.387 132.596 151.35 129.692",
    fill: "#653494"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.462 110.932C140.078 114.247 128.48 120.68 118.742 128.647C117.649 129.55 117.312 131.082 117.924 132.361C124.295 145.546 133.894 156.112 146.866 163.944L146.479 168.547C146.43 167.452 145.002 167.644 144.825 168.596C144.825 168.596 144.339 170.841 143.972 172.533C143.871 172.997 143.977 173.482 144.262 173.862C144.546 174.242 144.982 174.48 145.455 174.513C145.651 174.527 145.833 174.54 145.984 174.551C146.271 174.572 146.559 174.56 146.843 174.515C147.97 174.338 151.034 173.858 152.49 173.629C152.988 173.551 153.423 173.248 153.668 172.807C154.151 171.937 154.961 170.48 155.354 169.773C155.504 169.503 155.575 169.195 155.557 168.886C155.475 167.581 155.29 166.274 155.019 164.966C154.239 161.14 152.574 157.549 150.159 154.48C145.31 148.311 135.555 135.923 135.555 135.923",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.775 137.093L151.261 129.318",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.416 163.67L149.068 165.1",
    stroke: "black",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M143.705 132.496C144.956 133.744 146.111 135.141 148.26 135.014C154.184 134.263 150.747 120.315 145.039 113.827",
    stroke: "black",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.479 168.547L146.416 171.778",
    stroke: "black",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.577 201.425L101.648 199.541",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6387 197.652L97.2009 190.852",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.116 151.394C180.102 157.614 184.265 163.867 188.624 170.154C175.023 178.108 162.731 180.977 159.615 176.448C156.476 171.888 163.669 161.316 176.116 151.394ZM198.302 163.752C197.285 164.507 196.239 165.255 195.167 165.993C192.973 167.502 190.781 168.893 188.624 170.154L198.302 163.752ZM187.329 143.586C201.438 135.051 214.418 131.85 217.633 136.522C221.002 141.418 212.465 153.241 198.303 163.751C194.27 157.183 190.618 150.459 187.329 143.586Z",
    fill: "#653494"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.116 151.394C180.102 157.614 184.265 163.867 188.624 170.154C175.023 178.108 162.731 180.977 159.615 176.448C156.476 171.888 163.669 161.316 176.116 151.394ZM198.302 163.752C197.285 164.507 196.239 165.255 195.167 165.993C192.973 167.502 190.781 168.893 188.624 170.154L198.302 163.752ZM187.329 143.586C201.438 135.051 214.418 131.85 217.633 136.522C221.002 141.418 212.465 153.241 198.303 163.751C194.27 157.183 190.618 150.459 187.329 143.586Z",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.7204 58.5802C92.7613 70.9725 97.7913 82.8111 94.0753 86.1322C90.1498 89.6409 77.8702 82.3883 66.0744 69.8L68.9701 72.6496L82.7204 58.5802ZM61.3779 64.46C50.9452 51.8086 45.6444 39.5717 49.4327 36.1857C53.3402 32.6931 65.5271 39.8647 77.2742 52.3485L61.3779 64.46Z",
    fill: "#653494"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.7204 58.5802C92.7613 70.9725 97.7913 82.8111 94.0753 86.1322C90.1498 89.6409 77.8702 82.3883 66.0744 69.8L68.9701 72.6496L82.7204 58.5802ZM61.3779 64.46C50.9452 51.8086 45.6444 39.5717 49.4327 36.1857C53.3402 32.6931 65.5271 39.8647 77.2742 52.3485L61.3779 64.46Z",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9705 72.6499C68.9705 72.6499 80.8339 60.5109 83.7535 57.5233C84.1767 57.0905 84.6931 56.7596 85.2635 56.5559C86.5074 56.1113 88.7535 55.3094 89.707 54.9689C90 54.8644 90.2595 54.6829 90.4585 54.4438C91.3893 53.3249 94.1632 49.9911 94.5746 49.4966C94.6086 49.4556 94.6408 49.413 94.6713 49.369C94.9403 48.9771 96.344 46.9334 97.1233 45.7993C97.4216 45.3648 97.3493 44.7761 96.9544 44.4274C96.954 44.4269 96.954 44.4265 96.9535 44.4265C96.7093 44.2105 96.3492 44.1888 96.081 44.3743C95.0287 45.1009 92.4208 46.9021 91.0876 47.8229C90.6348 48.136 90.0153 48.0324 89.6887 47.5891C89.6883 47.5887 89.6878 47.5883 89.6878 47.5878C89.3818 47.1725 89.4523 46.5908 89.8485 46.2603C90.8825 45.3987 92.6876 43.894 92.6876 43.894C92.6876 43.894 90.8638 43.6554 90.1637 43.564C89.9861 43.5405 89.8054 43.5509 89.6312 43.5945C88.7457 43.8165 85.8277 44.5475 83.9721 45.0121C82.9477 45.269 82.0669 45.9216 81.5235 46.8268C80.8395 47.9657 79.9095 49.5153 79.3893 50.3817C79.1293 50.8149 78.7893 51.1946 78.3874 51.5006C75.2858 53.8635 61.377 64.459 61.377 64.459",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3855 63.5104C103.345 63.5104 114.498 63.5104 119.451 63.5104C120.893 63.5104 122.063 62.3409 122.063 60.8981C122.063 50.724 122.063 13.8112 122.063 3.63672C122.063 2.19429 120.893 1.02441 119.451 1.02441C111.144 1.02441 85.3975 1.02441 77.0908 1.02441C75.6484 1.02441 74.4785 2.19429 74.4785 3.63672C74.4785 11.0278 74.4785 32.5284 74.4785 47.6397",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.406 53.2744C176.406 52.5813 176.131 51.9169 175.641 51.4271C175.151 50.9373 174.486 50.6621 173.794 50.6621C169.322 50.6621 160.251 50.6621 155.78 50.6621C155.087 50.6621 154.423 50.9373 153.933 51.4271C153.442 51.9169 153.167 52.5813 153.167 53.2744C153.167 59.0402 153.167 72.7997 153.167 78.5655C153.167 79.2586 153.442 79.923 153.933 80.4128C154.423 80.9026 155.087 81.1778 155.78 81.1778C160.251 81.1778 169.322 81.1778 173.794 81.1778C174.486 81.1778 175.151 80.9026 175.641 80.4128C176.131 79.923 176.406 79.2586 176.406 78.5655C176.406 72.7997 176.406 59.0402 176.406 53.2744ZM39.272 90.1881C39.272 88.7452 38.1025 87.5758 36.6597 87.5758C33.632 87.5758 28.6712 87.5758 25.6436 87.5758C24.2007 87.5758 23.0312 88.7452 23.0312 90.1881C23.0312 94.2885 23.0312 102.189 23.0312 106.29C23.0312 107.733 24.2007 108.902 25.6436 108.902C28.6712 108.902 33.632 108.902 36.6597 108.902C38.1025 108.902 39.272 107.733 39.272 106.29C39.272 102.189 39.272 94.2885 39.272 90.1881Z",
    fill: "#F2F4FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M197.838 163.286C192.737 154.979 184.291 139.641 181.793 130.888L171.245 143.669C176.682 152.432 182.108 160.726 188.275 169.622",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.827 115.675C176.235 115.364 180.753 127.504 183.698 134.37C184.207 135.557 174.359 144.178 169.595 144.144C169.133 144.141 167.887 142.232 166.534 139.732C164.07 135.18 161.253 128.67 162.174 128.149C167.006 125.417 171.938 122.232 174.483 119.415C175.487 118.298 176.273 117.03 176.827 115.675Z",
    fill: "#E3E1FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.827 115.675C176.235 115.364 180.753 127.504 183.698 134.37C184.207 135.557 174.359 144.178 169.595 144.144C169.133 144.141 167.887 142.232 166.534 139.732C164.07 135.18 161.253 128.67 162.174 128.149C167.006 125.417 171.938 122.232 174.483 119.415C175.487 118.298 176.273 117.03 176.827 115.675Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02051 216.36H239.219",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6161 208.546C83.5045 213.439 74.8918 216.304 65.615 216.304C41.2278 216.304 21.4287 196.505 21.4287 172.118C21.4287 147.731 41.2278 127.932 65.615 127.932C86.7051 127.932 104.364 142.74 108.753 162.516",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0684 186.92C51.4564 191.876 56.0624 196.425 66.1263 196.425C75.5084 196.425 82.1606 191.808 82.1606 184.475C82.1606 168.045 51.7124 172.186 51.7124 157.86C51.7124 152.36 56.9153 147.812 65.8703 147.812C74.3141 147.812 78.1521 151.953 79.7726 154.669",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8447 144.133V200.103",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3838 144.133V200.103",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M200.2 121.984C186.251 126.775 177.033 123.923 180.853 115.758",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.784 123.909C194.378 123.645 196.086 123.251 197.888 122.721C196.918 129.616 191.107 134.966 184.008 135.216L173.92 129.907C172.809 126.884 173.977 118.69 176.826 115.675C177.64 114.813 180.853 115.758 180.853 115.758C178.943 119.84 180.292 122.595 183.863 123.729C185.032 124.101 186.438 124.299 188.046 124.313C188.043 124.313 188.041 124.314 188.039 124.316C188.037 124.318 188.036 124.32 188.037 124.323C188.1 125.204 188.318 125.944 188.735 126.707C188.847 126.915 189.058 127.05 189.293 127.067C189.529 127.083 189.756 126.977 189.895 126.787C190.817 125.55 191.926 124.561 193.26 123.868L192.784 123.909Z",
    fill: "#200849"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.686 116.006L177.377 117.93L180.822 127.295L189.152 134.037C187.496 134.794 185.655 135.215 183.717 135.215C176.709 135.215 170.979 129.703 170.629 122.782C172.172 121.637 173.504 120.499 174.483 119.415C175.404 118.39 176.143 117.237 176.686 116.006Z",
    fill: "#200849"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M183.524 115.984L177.405 115.207",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M193.893 110.012L192.84 112.534",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.826 104.601C181.908 99.2676 195.44 93.3981 205.257 104.931C207.3 107.33 208.301 110.446 208.04 113.587C207.778 116.727 206.275 119.634 203.864 121.663C202.197 123.064 200.973 124.094 200.973 124.094C195.433 121.055 198.166 116.126 194.33 114.595C194.33 114.595 195.127 112.686 195.767 111.154C195.975 110.655 195.977 110.094 195.771 109.594C195.566 109.094 195.17 108.696 194.671 108.488C194.67 108.488 194.67 108.487 194.67 108.487C193.63 108.054 192.436 108.544 192.003 109.583C191.35 111.147 190.527 113.118 190.527 113.118C185.314 111.17 188.423 106.243 183.523 105.266L176.826 104.601Z",
    fill: "#200849"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8369 213.008C93.8369 213.008 94.8457 213.663 95.6002 214.154C96.1305 214.498 96.747 214.685 97.3792 214.693C99.9893 214.725 106.978 214.812 106.978 214.812",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1162 211.166H102.609",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M143.931 214.726L169.313 215.037",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.074 216.304C143.573 212.409 144.192 209.364 146.43 207.545C146.811 207.24 147.344 207.214 147.752 207.48C148.097 207.692 148.533 207.975 148.97 208.26C150.154 209.03 151.635 209.187 152.955 208.682C153.792 208.362 154.56 208.068 154.56 208.068L155.404 204.665C155.404 204.665 157.448 206.314 158.364 207.753C158.941 208.659 160.006 209.839 160.716 210.588C161.147 211.052 161.686 211.402 162.284 211.608C163.572 212.06 166.026 212.905 167.49 213.409C168.252 213.672 168.887 214.214 169.264 214.927C169.264 214.927 169.265 214.927 169.265 214.928C169.419 215.218 169.409 215.568 169.239 215.85C169.07 216.131 168.765 216.304 168.437 216.304C162.84 216.304 144.074 216.304 144.074 216.304Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M98.086 207.591C99.1218 206.908 100.853 207.082 101.345 207.591M158.241 207.569C160.559 206.567 161.265 208.98 158.835 210.485L158.241 207.569ZM160.402 209.02C162.422 208.148 163.037 210.25 160.92 211.561L160.402 209.02ZM97.7852 205.96C98.8205 205.277 100.552 205.451 101.044 205.96H97.7852Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M157.277 195.901L155.403 204.666",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M147.878 197.039L147.245 206.959",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.556 135.922L147.528 130.888C155.25 137.331 162.054 144.852 167.614 153.833C168.963 156.022 169.304 158.685 168.551 161.143C165.571 170.891 157.799 196.25 157.799 196.25C156.158 192.373 144.916 196.99 144.948 200.575L149.207 174.144L152.491 173.629C152.989 173.551 153.423 173.248 153.669 172.807C154.152 171.937 154.962 170.479 155.354 169.773C155.505 169.502 155.576 169.195 155.558 168.885C155.476 167.581 155.29 166.274 155.02 164.966C154.24 161.14 152.575 157.548 150.159 154.48C145.31 148.311 135.556 135.922 135.556 135.922Z",
    fill: "#E3E1FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.556 135.922L147.528 130.888C155.25 137.331 162.054 144.852 167.614 153.833C168.963 156.022 169.304 158.685 168.551 161.143C165.571 170.891 157.799 196.25 157.799 196.25C156.158 192.373 144.916 196.989 144.948 200.575L149.207 174.144L152.491 173.629C152.989 173.551 153.423 173.248 153.669 172.807C154.152 171.937 154.962 170.479 155.354 169.773C155.505 169.502 155.576 169.195 155.558 168.885C155.476 167.581 155.29 166.274 155.02 164.966C154.24 161.14 152.575 157.548 150.159 154.48C145.31 148.311 135.556 135.922 135.556 135.922Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.528 203.004C147.528 203.004 147.879 199.361 147.879 197.039C144.292 199.035 143.79 201.974 147.528 203.004Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3789 45.8181L96.2914 41.25",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.987 29.3939C109.378 30.2878 112.217 34.5785 111.323 38.9694C110.43 43.3602 106.139 46.1998 101.748 45.306C97.3571 44.4121 94.518 40.1214 95.4114 35.7305C96.3052 31.3397 100.596 28.5001 104.987 29.3939ZM104.512 31.7254C107.617 32.3572 109.624 35.3905 108.992 38.4948C108.36 41.5991 105.327 43.6066 102.223 42.9745C99.1183 42.3427 97.1111 39.3094 97.7429 36.2051C98.3746 33.1008 101.408 31.0937 104.512 31.7254Z",
    fill: "#E3E1FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.987 29.3939C109.378 30.2878 112.217 34.5785 111.323 38.9694C110.43 43.3602 106.139 46.1998 101.748 45.306C97.3571 44.4121 94.518 40.1214 95.4114 35.7305C96.3052 31.3397 100.596 28.5001 104.987 29.3939ZM104.512 31.7254C107.617 32.3572 109.624 35.3905 108.992 38.4948C108.36 41.5991 105.327 43.6066 102.223 42.9745C99.1183 42.3427 97.1111 39.3094 97.7429 36.2051C98.3746 33.1008 101.408 31.0937 104.512 31.7254Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7114 43.3213L96.6465 44.2678",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6251 59.7126C93.0595 71.6861 97.678 82.9125 94.0752 86.1321C89.9504 89.8194 76.5993 81.6224 64.2801 67.8394C51.9605 54.0565 45.3074 39.8729 49.4326 36.1857C53.2649 32.7605 65.0603 39.5921 76.5932 51.6314",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPayrollLoansIcon);
export default __webpack_public_path__ + "static/media/no-payroll-loans-icon.74ff12115102ec1848888cdcec263230.svg";
export { ForwardRef as ReactComponent };